const f = {
  color: {
    background: "#ffffffff",
    action: {
      text: "#253642ff",
      link: {
        base: "#304ddbff",
        hover: "#263aadff",
        active: "#1c2674ff"
      }
    },
    bubble: {
      background: {
        from: "#f1f3f5ff",
        to: "#d1e8ffff",
        note: "#ffeeccff",
        embed: "#dfe6ebff"
      },
      border: {
        embed: "#dfe6ebff",
        embedFrom: "#c8d3deff",
        note: "#fabf5aff"
      },
      text: {
        default: "#253642ff",
        note: "#403521ff"
      },
      embedBodyText: "#405261ff",
      embedFromText: "#405261ff"
    },
    embed: {
      text: "#7e8e9eff",
      shadow: "#abb9c7ff",
      note: {
        shadow: "#fabf5aff",
        background: "#ffeeccff",
        text: "#574323ff"
      }
    },
    media: {
      text: "#7e8e9eff",
      shadow: "#abb9c7ff",
      note: {
        shadow: "#fabf5aff",
        background: "#ffeeccff",
        text: "#574323ff"
      },
      error: {
        shadow: "#fa7a64ff",
        text: "#e54a32ff"
      }
    }
  }
};
export {
  f as message
};
